<template>
    <div class="container">
        <div class="content">

            <img class="h-24 w-24 text-green-500 mx-auto" src="@/assets/images/pages/external-services/souqbox.gif"
                alt=""> 
            <img class="h-16 w-16 text-green-500 mx-auto mb-6 ml-4"
                src="@/assets/images/pages/external-services/xero-seeklogo.png" alt="">
                
            <h1 class="ml-6 mt-4">{{ message }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: 'Please wait..',
        };
    },
    mounted() {
        setTimeout(() => {
            window.location.href = `${this.$route.query.state}&code=${this.$route.query.code}`;
        }, 6000);
    }
};
</script>

<style scoped>
.container {
    display: flex;
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
    height: 100vh;
    /* Full viewport height */
    background-color: white;
}

.content {
    text-align: center;
    /* Center text inside content div */
}

img {
    /* width: 100px; */
    /* Adjust image size */
    height: auto;
    margin-bottom: 10px;
}
</style>